module.exports = __webpack_public_path__ + "img/mobile.9c370876.png";